import { MDSListBoxItemProps } from "@/mds/components/lists/list-box-item";
import { MDSText } from "@/mds/components/text";
import styled from "@emotion/styled";
import { ListBox } from "react-aria-components";

export const StyledListBox = styled(ListBox)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.smPlus};
  color: ${({ theme }) => theme.colors.text.primary};
  width: 100%;
` as typeof ListBox<MDSListBoxItemProps>;

export const StyledHeader = styled(MDSText)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-top: ${({ theme }) => theme.spacing.smd};
  margin-bottom: ${({ theme }) => theme.spacing.smd};
`;

export const StyledLeftAddon = styled.div`
  align-self: flex-start;
`;

export const StyledRightAddon = styled.div`
  align-self: flex-start;
`;
